import { render } from "./BaseSubpageBar.vue?vue&type=template&id=e1bc2e4a"
import script from "./BaseSubpageBar.vue?vue&type=script&lang=js"
export * from "./BaseSubpageBar.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__